export default "__VITE_ASSET__D6zvopM7__"